import { Pagination } from "../../../components/pagination/Pagination";
import useDocument from "../Hooks/useDocument";

const DocumentTeamDetail = () => {
  const { data, methods } = useDocument();
  const { controller, documentList, totalCount, personalDoc } = data;
  const { handlePagination } = methods;
  return (
    <div>
      {/* <div className=" my-4">
        <Button
          onClick={() => handleOpenModal("add")}
          className="dropDownButtons11 ms-4"
        >
          <AddIcon /> Add New
        </Button>
      </div> */}

      <div className="pt-3 px-4">
        <h3>Documents</h3>
        <hr />

        {documentList?.map((item, index) => (
          <div key={item._id} className="row mb-4">
            <div className="d-flex align-items-center justify-content-between">
              <div className="mt-4">
                <p>
                  <span className="fw-bold">Document :</span>
                  <span className="text-muted ms-2">{item?.name || "--"}</span>
                </p>
              </div>

              {/* <div className="mt-4">
        <div>
        <IconButton  onClick={() => handleOpenModal('edit', item)}><BorderColorIcon color="primary"/></IconButton>
        <IconButton onClick={()=>updateDelete(item._id)}><DeleteIcon color="error"/></IconButton>
        </div>
      </div> */}
            </div>

            <div className="col-lg-12 mt-4">
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "14px",
                  paddingTop: "10px",
                }}
              >
                {item.documents?.map((cur, fileIndex) => {
                  const filetype = cur.split(".").pop().toLowerCase();
                  const fileUrl = `${personalDoc}${cur}`;

                  // Common container style
                  const boxStyle = {
                    width: "90px",
                    height: "90px",
                    border: "1px solid #e3e3e3",
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    cursor: "pointer",
                    background: "#fafafa",
                  };

                  // IMAGE
                  if (["jpg", "jpeg", "png"].includes(filetype)) {
                    return (
                      <div key={fileIndex} style={boxStyle}>
                        <img
                          src={fileUrl}
                          alt="doc"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                          onClick={() => window.open(fileUrl)}
                        />
                      </div>
                    );
                  }

                  // VIDEO
                  //   if (["mp4", "wmv", "mov"].includes(filetype)) {
                  //     return (
                  //       <div key={fileIndex} style={boxStyle}>
                  //         <video
                  //           src={fileUrl}
                  //           controls
                  //           style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  //           onClick={() => window.open(fileUrl)}
                  //         />
                  //       </div>
                  //     );
                  //   }

                  // OTHER FILES (PDF, DOC, TXT etc.)
                  return (
                    <div key={fileIndex} style={boxStyle}>
                      <i
                        className="fa-sharp fa-regular fa-file"
                        style={{ fontSize: "48px", color: "red" }}
                        onClick={() => window.open(fileUrl)}
                      ></i>
                    </div>
                  );
                })}
              </div>
            </div>
            <hr className="mt-4" />
          </div>
        ))}

        {documentList.length === 0 && (
          <div style={{ textAlign: "center", padding: "20px", color: "#888" }}>
            <h5>No documents found</h5>
          </div>
        )}

        <Pagination
          count={totalCount}
          controller={controller}
          setController={handlePagination}
        />
      </div>
    </div>
  );
};

export default DocumentTeamDetail;
